export const drawerWidth = 280;
export const appbarHeight = 64;
export const bannerHeight = 46;
export const demoHeight = 69;
export const dashboardPaddingTop = 40;

export const bnw = { primary: "#000000", secondary: "#07217e" };
export const light = { primary: "#418dcb", secondary: "#3498db", primaryLight: "#DFF0FF" };
